module.exports = __webpack_public_path__ + "static/media/rugrats-player-login-bg.7ec1a020.png";